import { createContext, useContext } from 'react';

const VariantContext = createContext(null);

export function VariantProvider({ variant, children }) {
  return (
    <VariantContext.Provider value={variant}>
      {children}
    </VariantContext.Provider>
  );
}

export function useVariant() {
  return useContext(VariantContext);
}
